import useId from '../utils/useId';
import * as React from 'react';
export const stripeatlasSvg = React.forwardRef(function stripeatlasSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4.002c.59 0 1.13.334 1.393.862l4.842 9.68 5.1 10.203a1.557 1.557 0 0 1-.972 2.197l-.102.025c-.07.015-.14.024-.21.03l-.108.003L16 25.026 9.766 14.545l4.841-9.681A1.556 1.556 0 0 1 16 4.002Z',
      fill: '#FB0',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4.002c.59 0 1.13.334 1.393.862l4.842 9.68L16 25.027l-9.942 1.976a1.558 1.558 0 0 1-1.393-2.255l5.1-10.202 4.842-9.681A1.556 1.556 0 0 1 16 4.002Z',
      fill: `url(#bi_stripeatlas__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4.002c.59 0 1.13.334 1.393.862l4.842 9.68L16 25.027 9.766 14.545l4.841-9.681c.247-.495.737-.82 1.283-.858l.11-.004Z',
      fill: `url(#bi_stripeatlas__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_stripeatlas__a_${id_0}`,
          x1: 13.357,
          y1: 14.436,
          x2: 13.306,
          y2: 27.002,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FFD748',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.536,
          stopColor: '#FFCD48',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FFCB48',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_stripeatlas__b_${id_1}`,
          x1: 16.002,
          y1: 24.288,
          x2: 16.002,
          y2: 12.669,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FFAD00',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FF7600',
        }),
      ),
    ),
  );
});
stripeatlasSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stripeatlas = {
  category: 'brand',
  colorable: false,
  name: 'stripeatlas',
  svg: stripeatlasSvg,
};
